import React, { useState, type ReactNode } from "react"
import { Close } from "../Close"
import styles from "./index.module.scss"
import { i18n } from "@/i18n"
import OutlinedText from "../OutlinedText"
import Rule from "../Reward/components/Rule"
import { sfxPlay } from "@/assets/audios/sfx"

interface RewardWrapperProps {
    onClose: () => void
    children: ReactNode
    /** 是否显示规则按钮 */
    showRuleButton?: boolean
    /** 是否显示标题，传入标题内容 */
    showTitle?: boolean | ReactNode
}

const RewardWrapper: React.FC<RewardWrapperProps> = ({
    onClose,
    children,
    showRuleButton = false,
    showTitle = false,
}) => {
    const [showModal, setShowModal] = useState(false)
    function handleShowRule() {
        sfxPlay("dialog")
        setShowModal(true)
    }
    return (
        <>
            <div className={styles.addressPanel}>
                {/* 标题的特殊字体使用图片和文本 */}
                {showTitle && <div className={styles.bgTitle}></div>}
                {children}
                {/* 规则按钮 */}
                {showRuleButton && (
                    <div className={styles.ruleBtn} onClick={handleShowRule}>
                        <OutlinedText
                            text={i18n.get("rule.text_btn")}
                            fontFamily="SourceHanSansJP-VF"
                            fontSize={34}
                            strokeWidth={4}
                            fillColor="#8E7355"
                            strokeColor="#FDF8EF"
                        />
                    </div>
                )}
            </div>
            <Close onClose={onClose} />
            <Rule open={showModal} onClose={() => setShowModal(false)} />
        </>
    )
}

export default RewardWrapper
